import { Navigate, useParams } from "react-router-dom";

export default function DeprecatedRouteRedirect() {
  const { companyId } = useParams();
  return <Navigate to={`/company/${companyId}`} replace />;
}
